// extracted by mini-css-extract-plugin
module.exports = {"box":"box-DZ0G0ccK","footer":"footer-JwN-x-dr","right_link":"right_link-38312GEp","f_ico1":"f_ico1-3M2INNGn","v_dellink":"v_dellink-1jFdvFv-"};